import en from './en.json';
import fr from './fr.json';

export const dictionaryList = { en, fr};

export const languageOptions = { 
    en: "EN",
    fr: "FR"
};